module.exports = __webpack_public_path__ + "img/bj_zanwushujv.34fb0d97.png";